import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

@Pipe({ name: "dateFormat" })
export class MomentPipe implements PipeTransform {
  transform(value: moment.MomentInput, format: string): string {
    if (!value) {
      return;
    }
    return moment(value).utc().format(format);
  }
}
